export default "__VITE_ASSET__e956052b__"